/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { NumberConfig } from "./NumberConfig";
import { BaseProperty } from "./BaseProperty";
import { ArrayableProperty } from "./ArrayableProperty";
export const NumberProperty = core.serialization
    .object({
    config: NumberConfig.optional(),
})
    .extend(BaseProperty)
    .extend(ArrayableProperty);
